const basePath = process.env.REACT_APP_API_PATH

export const APIPath = {
  server: basePath,
  // auth
  auth: 'auth/login',

  users: 'users',
  userBlock: 'users/block',
  creators: 'users/creators',
  viewers: 'users/viewers',
  getUserFollowersCreators: 'follow/followers',
  getUserFollowingCreators: 'follow/following',

  competitions: 'competitions',
  adminCompetitions: 'competitions/admin',
  blockUser: 'users/block',
  videos: 'videos',
  adminVideos: 'videos/admin',
  adminFlaggedVideos: 'videos/admin/flagged',
  adminDeletedVideos: 'videos/admin/blocked',

  me: 'users/me',
  login: `${basePath}users/login`,
  register: `${basePath}auth/register`,
  setPassword: 'user/UpdatePassword',
  validateToken: `${basePath}users/ValidateToken`,
  forgotPassword: 'ForgotPassword',
  socialLogin: 'Users/ValidateProviderToken',
  checkUserExists: 'checkUserExists',
  forgetPassword: `${basePath}auth/forget-password`,
  resendToken: `${basePath}auth/resend-token`,
  verifyToken: `${basePath}auth/verify-reset-token`,
  resetPassword: `${basePath}auth/reset-password`,
  refreshToken: `${basePath}auth/refresh-token`,
  getSignedURL: `${basePath}aws/singed-url`,
  commentAdmin: `comments/admin`,
  videoAdmin: `videos/admin`,

  // Comment
  commentsByVideo: 'comments/by-video',
  flaggedComment: 'comments/admin/flagged',
  dashBoard: 'analytics/stats/overview',
  dashBoardLiveRound: 'analytics/stats/live-round',
}
